// frontend/src/components/JoinDiscord.js
import React from 'react';
import Layout from './Layout'; // Import the shared Layout component

/**
 * Component displayed when a user logs in but fails the Discord role check.
 * Instructs the user to join the Discord server.
 */
function JoinDiscord() { // Renamed function
  // Discord invite link
  const discordInviteLink = "https://discord.gg/exodusdayz";

  return (
    // Use the shared Layout component. No 'user' prop is passed,
    // so the Layout will render the "Login" button in the header.
    <Layout>
      {/* Container for page-specific content */}
      {/* Uses flexbox to center content vertically and horizontally within the Layout's main area */}
      <div className="relative z-20 flex flex-col items-center justify-center min-h-[calc(100vh-8rem)] text-center px-4"> {/* Adjust height calc if needed */}

        {/* Informational message */}
        <div className="bg-gray-800 bg-opacity-75 p-8 rounded-lg shadow-lg max-w-md">
          <h2 className="text-2xl font-semibold mb-4 text-yellow-300">Please Join Our Discord</h2>
          <p className="text-gray-200 mb-6">
            Access requires membership in our Discord server and specific roles. Please join us to continue!
          </p>

          {/* Button linking to Discord invite */}
          <a
            href={discordInviteLink}
            target="_blank" // Open link in a new tab
            rel="noopener noreferrer" // Security best practice for target="_blank"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105"
          >
            Join Discord Server
          </a>
           <p className="text-gray-400 mt-4 text-sm">
                After joining and accepting the rules, please try logging in again via the button in the header.
            </p>
        </div>

      </div>
    </Layout>
  );
};

export default JoinDiscord; // Renamed export
